var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStudiesOxfordAcademic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 576.7 143",
    style: {
      enableBackground: "new 0 0 576.7 143"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#011E41;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "178.4,1.8 164.9,1.8 142.9,32.5 121,1.8 107.4,1.8 134.5,38.3 107.2,75.1 120.7,75.1 142.9,43.9  165.1,75.1 178.8,75.1 151.5,38.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M454.9,49.2c8.9-3.8,14.8-11.4,14.8-22.5c0-15.9-11.3-24.8-29.7-24.8h-32v73.3h12.1V51.9h22 c6.9,6.5,12.8,14.6,17,23.2h14.8C469.3,65.9,461.2,55.3,454.9,49.2 M420,12.6h19.6c10.7,0,17.6,4.9,17.6,14.5 c0,9.7-6.7,14.3-16.9,14.3H420V12.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M537.7,1.8h-27.4v73.3h27.4c23.7,0,39-14.8,39-36.7S561.4,1.8,537.7,1.8 M536.8,64.3h-14.4V12.6h14.4 c15.6,0,27.5,9.3,27.5,25.9S552.4,64.3,536.8,64.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.2,0C18,0,0,17.2,0,38.3c0,21.2,18,38.3,39.2,38.3s39.2-17.2,39.2-38.3S60.4,0,39.2,0 M39.2,65.7 c-15,0-27.7-12.2-27.7-27.3s12.7-27.3,27.7-27.3s27.7,12.2,27.7,27.3S54.2,65.7,39.2,65.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M333,0c-21.2,0-39.2,17.2-39.2,38.3c0,21.2,18,38.3,39.2,38.3s39.2-17.2,39.2-38.3S354.3,0,333,0 M333,65.7 c-15,0-27.6-12.2-27.6-27.3s12.7-27.3,27.7-27.3s27.7,12.2,27.7,27.3C360.8,53.5,348.1,65.7,333,65.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M211.2,75.1h12.1V48.7h35.3c2.2-3.2,3.8-6.6,5.2-10.5h-40.5V12.6h44.8V1.8h-57L211.2,75.1L211.2,75.1z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M235.6,131h-13.7l-3.2,11.1h-7.4l13.4-40.9h8.5l13.3,40.9h-7.7L235.6,131z M233.9,125.3l-1.4-5 c-1.3-4.3-2.5-9-3.7-13.5h-0.3c-1.1,4.6-2.3,9.2-3.6,13.5l-1.4,5H233.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M279.9,100.4c5,0,9.1,2.4,11.6,5.2l-4,4.5c-2.1-2.1-4.4-3.4-7.6-3.4c-6.7,0-11.5,5.6-11.5,14.8 c0,9.3,4.4,14.9,11.3,14.9c3.6,0,6.3-1.5,8.6-4.1l4,4.4c-3.3,3.8-7.6,5.9-12.8,5.9c-10.4,0-18.6-7.5-18.6-21.1 C261,108.3,269.4,100.4,279.9,100.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M330.5,131h-13.7l-3.2,11.1h-7.4l13.4-40.9h8.5l13.3,40.9h-7.7L330.5,131z M328.8,125.3l-1.4-5 c-1.3-4.3-2.5-9-3.7-13.5h-0.3c-1.1,4.6-2.3,9.2-3.6,13.5l-1.4,5H328.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M359.7,101.1h10.9c12.5,0,19.9,6.8,19.9,20.3c0,13.6-7.4,20.6-19.6,20.6h-11.3v-40.9H359.7z M370.1,136.2 c8.3,0,13-4.7,13-14.8c0-10-4.8-14.4-13-14.4H367v29.1h3.1V136.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M410.2,101.1h24.6v6.1h-17.3v10.4h14.7v6.1h-14.7v12.1h17.9v6.1h-25.2V101.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M456,101.1h7.9l7.4,20.1l2.7,7.8h0.3l2.7-7.8l7.2-20.1h8V142h-6.8v-18.7c0-3.8,0.6-9.3,0.9-13H486l-3.3,9.3 l-7.1,18.6h-3.3l-7.1-18.6l-3.3-9.3h-0.2c0.3,3.8,0.9,9.2,0.9,13V142H456V101.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M514.9,101.1h7.3V142h-7.3V101.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M561.6,100.4c5,0,9.1,2.4,11.6,5.2l-4,4.5c-2.1-2.1-4.4-3.4-7.6-3.4c-6.7,0-11.5,5.6-11.5,14.8 c0,9.3,4.4,14.9,11.3,14.9c3.6,0,6.3-1.5,8.6-4.1l4,4.4c-3.3,3.8-7.6,5.9-12.8,5.9c-10.4,0-18.6-7.5-18.6-21.1 C542.7,108.3,551.1,100.4,561.6,100.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudiesOxfordAcademic);
export default __webpack_public_path__ + "static/media/studies-OxfordAcademic.0dfeb27054b64afc123add00f13f6229.svg";
export { ForwardRef as ReactComponent };